import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { GroupType, GroupTypeEdit } from '../../../store/entities/groupType/groupType.types';
import { APIManagerConfig } from '../apiManager';

const GroupTypesServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getGroupTypeList: (): Promise<GroupType[]> =>
      HTTPBase.get(`farm/${config.farmId}/grouptypes`).then((res) => res.data),
    addGroupType: (description: string, groupClassId: number, formName: FormName): Promise<GroupType> =>
      HTTPBase.post(
        `farm/${config.farmId}/grouptypes`,
        { description, groupClassCode: groupClassId },
        { headers: { formName } },
      ).then((res) => res.data),
    deleteGroupType: (groupTypeId: string, formName: FormName): Promise<void> =>
      HTTPBase.delete(`farm/${config.farmId}/grouptypes/${groupTypeId}`, { headers: { formName } }).then(
        (res) => res.data,
      ),
    editGroupType: (groupType: GroupTypeEdit, formName: FormName): Promise<void> =>
      HTTPBase.patch(`farm/${config.farmId}/grouptypes/${groupType.id}`, groupType, { headers: { formName } }).then(
        (res) => res.data,
      ),
  };
};
export default GroupTypesServiceFactory;
